<template>
  <div class="Booking">
    <Message v-if="!!serveTip">
      {{ serveTip }}
    </Message>
    <el-form :model="form" ref="myForm" :rules="rules" hide-required-asterisk>
      <!-- 車輛的註冊編號 -->
      <el-form-item :label="$t('message.Booking.applicantIdentType')" prop="applicantIdentType">
        <el-select
          v-model="form.applicantIdentType"
          filterable
          :placeholder="$t('message.Verification.input')"
        >
          <el-option
            v-for="item in companyType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('message.Booking.applicantIdentNo')" prop="applicantIdentNo">
        <slot name="label">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('message.companyBrNo_tooltips')"
            placement="bottom"
          >
            <i class="el-icon-warning-outline warn-icon"></i>
          </el-tooltip>
        </slot>
        <el-input
          v-model="form.applicantIdentNo"
          :placeholder="$t('message.Verification.input')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.Booking.regAndIdNo')" prop="name">
        <el-input
          :placeholder="$t('message.Verification.input')"
          @focus="onRegistNoFocus"
          ref="registrationNo"
          v-model="form.name"
          maxlength="8"
        ></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model.number="form.mobile"
          :placeholder="$t('message.Verification.input')"
          maxlength="8"
        ></el-input>
      </el-form-item>
      <!-- 手機驗證碼 -->
      <el-form-item :label="$t('message.Verification.phone_code')" prop="captcha">
        <div class="captcha_row" style="width: 100%">
          <el-input
            v-model="form.captcha"
            :placeholder="$t('message.Verification.input')"
            @keyup.enter.native="submit"
          ></el-input>
          <el-button
            v-show="showGetCodeBtn"
            type="primary"
            class="getVerify_btn"
            @click="getCode"
            :disabled="!this.form.mobile"
            :loading="getCodeLoading"
          >
            {{ $t("message.get_phone_code") }}
          </el-button>
          <el-button v-show="!showGetCodeBtn" type="primary" class="getVerify_btn" disabled
            >{{ count }}{{ $t("message.second") }}</el-button
          >
        </div>
      </el-form-item>
      <el-form-item prop="isSave" :inline-message="true">
        <div class="itnal_info_box">
          <div v-html="$t('message.Booking.isSaveTip')"></div>
          <div class="isSave_box">
            <el-radio v-model="form.isSave" label="yes">
              {{ $t("message.Booking.isSaveArr.yes") }}
            </el-radio>
            <el-radio v-model="form.isSave" label="no">
              {{ $t("message.Booking.isSaveArr.no") }}
            </el-radio>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn @click="submit" :loading="loading">{{
          $t("message.verify_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
  </div>
</template>

<script>
import * as BookingApplicationAPI from "@/api/Booking/BookingApplicationAPI";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
import i18n from "../../../../public/lang/index";
import CaptchaApi from "@/api/Booking/CaptchaApi";
import GradientBtn from "../../../components/GradientBtn";
import RegistrationNoDialog from "@/components/RegistrationNoDialog";
import { wordBreak } from "@/filters";
import { checkServerStatus } from "@/util/util";
import Message from "../../../components/Message";

export default {
  name: "Booking",
  components: { GradientBtn, RegistrationNoDialog, Message },
  data() {
    return {
      loading: false,
      showGetCodeBtn: true, // 顯示獲取驗證碼按鈕，否則倒計時
      getCodeLoading: false, // 獲取倒計時加載動畫
      showRegistrationNoDialog: false,
      timer: null, // 再次發送驗證碼倒計時 循環事件
      count: "", // 倒計時數
      isGetCode: false, // 判斷是否已經發送過驗證碼
      serveTip: "",
      rules: {
        serviceCode: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: ["blur", "change"],
          },
        ],
        applicantIdentType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        applicantIdentNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          {
            pattern: /[6]{1}[0-9]{7}/,
            message: i18n.t("message.formRuleMessage.macauMobile"),
            trigger: ["blur", "change"],
          },
        ],
        captcha: [
          {
            max: 10,
            message: i18n.t("message.formRuleMessage.maxLength10"),
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: ["blur", "change"],
          },
          {
            max: 8,
            message: i18n.t("message.formRuleMessage.maxLength8"),
            trigger: ["blur", "change"],
          },
        ],
        isSave: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: ["blur", "change"],
          },
        ],
      },
      companyType: [
        {
          code: "BM",
          label: "message.Booking.companyTypeBM",
        },
        {
          code: "CO",
          label: "message.Booking.companyTypeCO",
        },
        // {
        //   code: "EM",
        //   label: "message.Booking.companyTypeEM",
        // },
        {
          code: "SO",
          label: "message.Booking.companyTypeSO",
        },
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$route.params.serviceType || this.$route.meta.businessType;
    },
  },
  methods: {
    // 獲取驗證碼
    getCode() {
      this.rules.captcha.splice(1, 1);
      this.rules.isSave.splice(0, 1);
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            const mobile = this.form.mobile;
            if (mobile) {
              const { serviceCode } = this.form;
              const language = this.$t("message.lang");
              this.getCodeLoading = true;
              CaptchaApi.mobileQueryCaptcha(serviceCode, mobile, language)
                .then(() => {
                  this.getCodeLoading = false;
                  this.showGetCodeBtn = false;
                  this.isGetCode = true;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.showGetCodeBtn = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                })
                .catch((error) => {
                  this.getCodeLoading = false;
                  this.$error(error);
                });
            }
          }
        } 
        this.rules.captcha.push({
          required: true,
          message: i18n.t("message.formRuleMessage.notNull"),
          trigger: "blur",
        });
        this.rules.isSave.push({
          required: true,
          message: i18n.t("message.formRuleMessage.notNull"),
          trigger: ["blur", "change"],
        });
      });
    },
    // 獲取業務信息
    async getBusiness() {
      const business = await ServiceTypeConfigAPI.getDetails(this.serviceType);
      if (!business) {
        throw this.$t("message.ErrorMessage.BUSINESS_NOT_FOUND");
      }
      // 設置頁面標題
      this.$store.commit("changeServiceTypeConfig", {
        nameEn: wordBreak(business.nameEn),
        namePt: wordBreak(business.namePt),
        nameSc: wordBreak(business.nameSc),
        nameTc: wordBreak(business.nameTc),
      });
      return business;
    },
    submit() {
      if (!this.isGetCode) {
        this.$message({
          type: "warning",
          message: this.$t("message.getCode_first"),
        });
        return false;
      }

      this.$refs.myForm.validate((valid) => {
        if (valid) {
          // 判斷是否為開發環境
          this.check();
        }
      });
    },
    // 驗證校長准入
    async check() {
      try {
        this.loading = true;
        const { mobile, name, captcha, applicantIdentType, applicantIdentNo,  vin } = this.form;
        // dsat-驗證澳方批准信息
        const { token } = await BookingApplicationAPI.login({
          carNo: name,
          applicantIdentType,
          applicantIdentNo,
          vin,
          mobile,
          captcha,
        });
        localStorage.setItem("form", "");
        this.$store.commit("changeDocumentType", []);
        localStorage.setItem("verifyForm", JSON.stringify({...this.form, token}));
        this.loading = false;

        // 判斷是否儲存
        if (this.form.isSave === "yes") {
          localStorage.setItem("bookingStoreInfo", JSON.stringify(this.form));
        } else {
          localStorage.setItem("bookingStoreInfo", "");
        }
        this.toSetBookingPage(this.form.serviceCode);
      } catch (error) {
        this.loading = false;
        this.$error(error);
      }
    },
    // 關閉註冊編號彈窗
    handleClose() {
      this.showRegistrationNoDialog = false;
    },
    // 車輛的註冊編號儲存
    registNoSave(data) {
      this.$set(this.form, "name", data.registrationNo);
      this.$set(this.form, "vin", data.identificationNo);
      this.showRegistrationNoDialog = false;
    },
    // 驗證車身註冊編號弹窗
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
    toSetBookingPage(code) {
      localStorage.setItem("serviceType", this.serviceType)
      this.$router.push(`/booking/${code}`);
    },
  },
  async created() {
    try {
      await this.getBusiness();
      await checkServerStatus(this.serviceType);
    } catch (error) {
      if(typeof error === "string") {
        this.serveTip = error
      }
      this.$error(error);
    }

      // 判斷是否已經提交過校驗 並通過了
    let verifyForm = localStorage.getItem("verifyForm");
    verifyForm = verifyForm ? JSON.parse(verifyForm) : {};
    this.$store.commit("changeVerifyForm", {
      ...verifyForm,
      serviceCode: this.serviceType,
    });
    if (
      this.form &&
      this.form.mobile &&
      this.form.name &&
      this.form.vin &&
      this.form.serviceCode &&
      this.form.applicantIdentType &&
      this.form.applicantIdentNo &&
      this.form.token
    ) {
      this.toSetBookingPage(this.serviceType);
    }
    let bookingStoreInfo = JSON.parse(localStorage.getItem("bookingStoreInfo") || "{}");
    if (bookingStoreInfo.isSave === "yes") {
      this.form = {
        ...bookingStoreInfo,
        serviceCode: this.serviceType,
        captcha: "",
      };
    }
    this.$nextTick(() => {
      this.$refs.myForm.clearValidate();
    });
  },
};
</script>

<style lang="scss" scoped>
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
.submit_btn {
  text-align: center;
  margin: 76px 0;
}
.itnal_info_box {
  background: #fffcf0;
  border: 1px solid #f7b463;
  border-radius: 6px;
  margin: 34px auto 0;
  overflow: hidden;
  font-size: 14px;
  padding: 15px 24px;
  text-align: justify;
  line-height: 1.5em;
  /deep/.colorRed {
    color: #d9001b;
  }
  .isSave_box {
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    padding: 24px 0;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
